__turbopack_context__.v({
  "CardLinked": "AIzMmG_CardLinked",
  "CardLinked__asset": "AIzMmG_CardLinked__asset",
  "CardLinked__content": "AIzMmG_CardLinked__content",
  "CardLinked__inner": "AIzMmG_CardLinked__inner",
  "custom": "AIzMmG_custom",
  "custom-2": "AIzMmG_custom-2",
  "double": "AIzMmG_double",
  "type-sidelines": "AIzMmG_type-sidelines",
  "type-sidelines-dotted": "AIzMmG_type-sidelines-dotted",
});
